"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBox = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const Debounce_hooks_1 = require("../hooks/Debounce.hooks");
const StyledSearchBox = styled_components_1.default.div `
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 20px;
  .search {
    flex: 1;
    display: flex;
    padding: 5px;
    max-width: 512px;
    .MuiInputBase-root {
      width: 100%;
    }
  }
`;
const SearchBox = props => {
    const { value, children, placeholder = 'Search', onSearch } = props;
    const valueRef = (0, react_1.useRef)(value);
    const onSearchRef = (0, react_1.useRef)(onSearch);
    const [search, setSearch] = (0, react_1.useState)(value || '');
    const debouncedSearch = (0, Debounce_hooks_1.useDebounce)(search, 300);
    (0, react_1.useEffect)(() => {
        valueRef.current = value;
    }, [value]);
    (0, react_1.useEffect)(() => {
        onSearchRef.current = onSearch;
    }, [onSearch]);
    // update search to latest value
    (0, react_1.useEffect)(() => setSearch(value || ''), [value]);
    (0, react_1.useEffect)(() => {
        var _a;
        // only update when debounced value changed
        if (valueRef.current !== debouncedSearch) {
            (_a = onSearchRef.current) === null || _a === void 0 ? void 0 : _a.call(onSearchRef, debouncedSearch);
        }
    }, [debouncedSearch]);
    return (react_1.default.createElement(StyledSearchBox, { className: 'search-box' },
        react_1.default.createElement(core_1.Paper, { className: 'search' },
            react_1.default.createElement(core_1.IconButton, { "aria-label": 'search', size: 'small' },
                react_1.default.createElement(Search_1.default, null)),
            react_1.default.createElement(core_1.InputBase, { id: 'search-textfield', placeholder: placeholder, type: 'search', value: search, onChange: event => setSearch(event.target.value), onKeyPress: event => {
                    if (event.key === 'Enter') {
                        onSearch === null || onSearch === void 0 ? void 0 : onSearch(search);
                    }
                } })),
        children));
};
exports.SearchBox = SearchBox;
exports.default = exports.SearchBox;
//# sourceMappingURL=SearchBox.js.map